import * as actions from './building.actions';
import watch from './building.operations';
import reducer, { initState } from './building.reducers';

export { actions, watch, initState };

export default reducer;
